import React, {useEffect} from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";

const ThankYou = ({lang, setLang, formData, backstep, sendData, didItSend, setDidItSend}) => {
  useEffect(() => {
    if (!didItSend) {
      sendData();
      setDidItSend(true);
      console.log('formData updated:', formData);
    }
  }, []);

  
  return (
    <>
<>
  <header className="c-site-header">
    <a className="c-site-header__skip js-site-header-skip" href="#main">
      Skip to main content
    </a>
    <div className="o-wrapper">
      <a
        className="c-site-header__logo-link"
        href="./"
        aria-label="Go to home page"
      >
        <img
          className="c-site-header__logo"
          src="images/components/site-header/logo-blf-specialty.svg"
          alt="Bluefire Specialty Logo"
          width={100}
          height={34}
        />
      </a>

      <div className="c-site-header__controls c-header-controls">
      <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
      </div>
    </div>
  </header>
  <main className="c-main-content">
    <div className="c-section">
      <div className="o-wrapper o-wrapper--small">
       
        <div className="c-section__content">
          <div className="c-steps">
            <ul className="o-list-bare c-steps__list">
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                  <div className="c-steps__circle" />
            

                </div>
              </li>
              <li className="o-list-bare__item c-steps__item  c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>                  <div className="c-steps__circle" />
                 
                </div>
              </li>
            </ul>
          </div>
          <div className="c-content">
            <div className="c-thanks">
              <div className="c-thanks__content">
                <div className="c-thanks__title">
                  <img
                    className="c-thanks__image"
                    src="images/components/thanks/ima-thanks.svg"
                    aria-hidden="true"
                    width={60}
                    height={60}
                  />
                  <h1 className="c-thanks__title">
                  {lang === 'eng' ? 'Thank You!' : '¡Muchas gracias!'}
                  </h1>
                </div>
           
                <div className="c-thanks__text">
                  <p>
                    {lang === 'eng' 
                      ? <>One of our representatives will reach out to you shortly. For immediate inquiries, please don't hesitate to email us at <a href="mailto:cotizar@bluefireins.com" style={{color: '#1479CA'}}>cotizar@bluefireins.com</a></>
                      : <>Uno de nuestros representantes se pondrá en contacto con usted en breve. Para consultas inmediatas, por favor no dude en enviarnos un correo electrónico a <a href="mailto:cotizar@bluefireins.com" style={{color: '#1479CA'}}>cotizar@bluefireins.com</a></>}
                  </p>                </div>
          


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On <br/></> : <>Listado de entidades/números de licencia por estado <br/> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
</>

    </>

  );
}
export default ThankYou;